import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { GamePlayService } from './gamePlayService.service';

@Component({
  selector: 'app-game-play',
  templateUrl: './game-play.component.html',
  styleUrls: ['./game-play.component.scss']
})
export class GamePlayComponent implements OnInit, OnDestroy {
  @Input() game;
  newPlayer = false;
  bonus = false;
  score: number;
  level: number;
  lifes: number;
  lifesArray: number[];
  levelSub: Subscription;
  scoreSub: Subscription;
  lifesSub: Subscription;
  bonusSub: Subscription;
  newPlayerSub: Subscription;

  constructor(public gamePlayService: GamePlayService) { }

  ngOnInit(): void {
    this.lifesSub = this.gamePlayService.lifes.subscribe(lifes => {
      this.lifes = lifes;
      if (lifes <= 2) {
        let cardiogram = document.getElementById('cardiogram');
        cardiogram.classList.add('heartBeat');
        setTimeout(() => {
          cardiogram.classList.remove('heartBeat');
        }, 1600);
        document.getElementById('heart' + lifes.toString()).classList.add('fade-off');
      }
    });
    this.lifesArray = Array(3).fill(0);
    this.scoreSub = this.gamePlayService.score.subscribe(score => {
      this.score = score;
      if (this.score != 0) {
        document.getElementById('score-scale').classList.add('scale');
        setTimeout(() => {
          document.getElementById('score-scale').classList.contains('scale') ? document.getElementById('score-scale').classList.remove('scale') : null;
        }, 2000);
      }
    });
    this.newPlayerSub = this.gamePlayService.newPlayer.subscribe(player => {
      this.newPlayer = player;
    });
    this.levelSub = this.gamePlayService.level.subscribe(level => {
      this.level = level;
    });
    this.bonusSub = this.gamePlayService.bonus.subscribe(bonus => {
      console.log('BONUSSS', bonus);
      
      this.bonus = bonus;
      if (this.bonus) {
        setTimeout(() => {
          document.getElementById('combo-img').classList.add('combo-anim');
          setTimeout(() => {
          document.getElementById('combo-img').classList.remove('combo-anim');
          }, 2000);
        }, 100);
      }
    });
  }

  ngOnDestroy() {
    this.lifesSub.unsubscribe();
    this.scoreSub.unsubscribe();
    this.newPlayerSub.unsubscribe();
    this.levelSub.unsubscribe();
    this.bonusSub.unsubscribe();
  }
}
